<script setup>
import axios from 'axios';
import { ElButton, ElIcon } from 'element-plus';
import { CircleCloseFilled } from '@element-plus/icons-vue';
import { ref, onMounted } from 'vue';
import { countBy } from 'lodash';

const props = defineProps(['modelValue', 'multiple', 'label']);


const preview_images = ref([]);
const loading_preview = ref(false);
const emit = defineEmits(['update:modelValue']);

onMounted(() => { 
    const image_ids = props.modelValue;
    
    if(!props.multiple && image_ids === ''){
        return; 
    }

    if(props.multiple && image_ids.length === 0){
        return; 
    }
    
    loading_preview.value = true;
    // send rest api request to get all media
    axios.get('/wp-json/wp/v2/media', {
        params: {
            include: image_ids,
            per_page: 100
        }
    }).then((response) => {
        const images = [];
        
        for(let image in response.data) {
            
            images[image] = {
                id: response.data[image].id,
                url: response.data[image].media_details.sizes.full.source_url,
                alt: response.data[image].alt_text
            }
        }
        preview_images.value = images;
        loading_preview.value = false;
    }).catch((error) => {
        loading_preview.value = false;
    });
});

const openMediaUploader = () => {
    const mediaUploader = wp.media({
        title: 'Select Product Image',
        button: {
            text: 'Select Product Image'
        },
        multiple: props.multiple
    });

    mediaUploader.on('select', () => {
        const attachments = mediaUploader.state().get('selection').toJSON();

        if(props.multiple){
            preview_images.value = [...preview_images.value, ...attachments];
        }else{
            preview_images.value = attachments;
        }

        // loop on attachments
        let images = [];
        for(let attachment in attachments) {
            images = [...images, attachments[attachment].id ];
        }

        if(props.multiple){
            images = [...images, ...props.modelValue];
            emit('update:modelValue', images);
        }else{
            if(images.length){
                images = images[0];
            }else{
                images = '';
            }
            emit('update:modelValue', images);
        }
        
    });

    mediaUploader.open();
}

const removeMedia = (id) => {
    const images = preview_images.value;
    const index = images.findIndex(image => image.id === id);
    images.splice(index, 1);
    preview_images.value = images;

    // upate moduleValue with image ids 
    let remaining_images = [];
    for(let image in images) {
        remaining_images = [...remaining_images, images[image].id ];
    }

    if(props.multiple){
        emit('update:modelValue', remaining_images);    
    }else{
        if(remaining_images.length){
            remaining_images = remaining_images[0];
        }else{
            remaining_images = '';
        }
        emit('update:modelValue', remaining_images);
    }
    
}

</script>
    
<template>
    <a href="#" class="fpe-upload-media" @click="openMediaUploader">{{ props.label }}</a>
    <div class="fpe-preview-images" :loading="loading_preview">
        <div v-for="image in preview_images" :key="image.id">
            <img :src="image.url" :alt="image.alt" />
            <ElIcon @click="removeMedia(image.id)">
                <CircleCloseFilled />    
            </ElIcon>
        </div>
    </div>    
</template>